<!-- start page title -->
<app-pagetitle
  *ngIf="!hideTitle"
  title="Dashboard Call Center"
  [breadcrumbItems]="breadCrumbItems"
></app-pagetitle>
<!-- Mensagem de Erro -->
<div *ngIf="error" class="alert alert-danger mb-4" role="alert">
  <i class="fas fa-exclamation-triangle me-2"></i>
  {{ error }}
</div>

<!-- Loading -->
<div *ngIf="isLoading" class="text-center py-5">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Carregando...</span>
  </div>
  <p class="mt-2 text-muted">Carregando gráficos do dashboard...</p>
</div>

<!-- Gráficos -->

  <div *ngIf="!isLoading" class="row">
    <!-- Linha 1: Gráficos Principais -->
    <div class="col-xl-6 col-lg-6 col-md-6 mb-3">
      <div class="card">
        <div class="card-body">
          <h6 class="card-title mb-2">
            Status Finais Qualificados
            <i class="fas fa-question-circle ms-1" 
               ngbTooltip="Visualize a distribuição de status dos contatos qualificados. Identifique quantos contatos estão em cada etapa do funil de vendas."
               placement="top"
               style="cursor: help; font-size: 0.85rem;"></i>
          </h6>
          <div style="position: relative; height: 280px;">
            <canvas id="statusQualificadosChart"></canvas>
          </div>
        </div>
      </div>
    </div>
  
    <div class="col-xl-6 col-lg-6 col-md-6 mb-3">
      <div class="card">
        <div class="card-body">
          <h6 class="card-title mb-2">
            Volume de Mensagens por Atendente
            <i class="fas fa-question-circle ms-1" 
               ngbTooltip="Compare o volume de mensagens enviadas por cada atendente. Identifique os atendentes mais ativos e o desempenho individual da equipe."
               placement="top"
               style="cursor: help; font-size: 0.85rem;"></i>
          </h6>
          <div style="position: relative; height: 280px;">
            <canvas id="mensagensAtendenteChart"></canvas>
          </div>
        </div>
      </div>
    </div>
  
    <!-- Linha 2: Gráfico Temporal -->
    <div class="col-12 mb-3">
      <div class="card">
        <div class="card-body">
          <h6 class="card-title mb-2">
            Contatos Atualizados com Mensagem
            <i class="fas fa-question-circle ms-1" 
               ngbTooltip="Acompanhe a evolução de contatos atualizados com mensagens ao longo do tempo. Identifique períodos de maior atividade e tendências de engajamento."
               placement="top"
               style="cursor: help; font-size: 0.85rem;"></i>
          </h6>
          <div style="position: relative; height: 300px;">
            <canvas id="contatosAtualizadosChart"></canvas>
          </div>
        </div>
      </div>
    </div>
  
    <!-- Linha 3: Taxa de Aproveitamento por Lista (linha inteira) -->
    <div class="col-12 mb-3">
      <div class="card">
        <div class="card-body">
          <h6 class="card-title mb-2">
            Taxa de Aproveitamento por Lista
            <i class="fas fa-question-circle ms-1" 
               ngbTooltip="Compare o aproveitamento de diferentes listas de contatos. Identifique quais listas têm maior taxa de qualificação e quais precisam de mais atenção."
               placement="top"
               style="cursor: help; font-size: 0.85rem;"></i>
          </h6>
          <div style="position: relative; height: 400px;">
            <canvas id="aproveitamentoListasChart"></canvas>
          </div>
        </div>
      </div>
    </div>
  
    <!-- Linha 4: Contatos Sem Mensagem e Resumo de Performance por Lista -->
    <div class="col-xl-6 col-lg-12 mb-3">
      <div class="card">
        <div class="card-body">
          <h6 class="card-title mb-2">
            Contatos Sem Mensagem (Pendentes)
            <i class="fas fa-question-circle ms-1" 
               ngbTooltip="Identifique contatos que ainda não receberam nenhuma mensagem. Priorize o contato com esses leads para melhorar a taxa de engajamento."
               placement="top"
               style="cursor: help; font-size: 0.85rem;"></i>
          </h6>
          <div style="position: relative; height: 320px;">
            <canvas id="contatosSemMensagemChart"></canvas>
          </div>
        </div>
      </div>
    </div>

    <!-- Resumo de Performance por Lista -->
    <div class="col-xl-6 col-lg-12 mb-3">
      <div class="card">
        <div class="card-header">
          <h6 class="card-title mb-0">
            <i class="fas fa-info-circle me-2"></i>
            Resumo de Performance por Lista
          </h6>
        </div>
        <div class="card-body">
          <!-- Seletor de Lista -->
          <div class="mb-3">
            <label for="listaResumo" class="form-label form-label-sm">Selecione uma lista para ver o
              resumo:</label>
            <select class="form-select form-select-sm" id="listaResumo" [(ngModel)]="listaIdParaResumo"
              (change)="carregarResumoPerformanceLista()">
              <option [ngValue]="null">Selecione uma lista</option>
              <option *ngFor="let lista of listas" [ngValue]="lista.id">{{ lista.nomeLista }}</option>
            </select>
          </div>

          <!-- Loading -->
          <div *ngIf="carregandoResumo" class="text-center py-3">
            <div class="spinner-border spinner-border-sm text-primary" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
          </div>

          <!-- Resumo -->
          <div *ngIf="resumoPerformanceLista && !carregandoResumo">
            <!-- Cabeçalho -->
            <div class="mb-3 pb-2 border-bottom">
              <h5 class="mb-1">
                <i class="fas fa-list me-2"></i>
                {{ resumoPerformanceLista.nomeLista }}
              </h5>
            </div>

            <!-- Métricas Principais -->
            <div class="row g-2 mb-3">
              <div class="col-6">
                <div class="p-2 bg-light rounded">
                  <small class="text-muted d-block">Total de Contatos</small>
                  <strong class="fs-5">{{ resumoPerformanceLista.totalContatos | number }}</strong>
                </div>
              </div>
              <div class="col-6">
                <div class="p-2 bg-light rounded">
                  <small class="text-muted d-block">Qualificados</small>
                  <strong class="fs-5 text-success">{{ resumoPerformanceLista.totalQualificados | number
                    }}</strong>
                  <small class="text-muted d-block">{{ resumoPerformanceLista.totalNaoQualificados | number
                    }} não qualificados</small>
                </div>
              </div>
              <div class="col-6">
                <div class="p-2 bg-light rounded">
                  <small class="text-muted d-block">Com Mensagem</small>
                  <strong class="fs-5 text-info">{{ resumoPerformanceLista.contatosComMensagem | number
                    }}</strong>
                  <small class="text-muted d-block">{{ resumoPerformanceLista.contatosSemMensagem | number
                    }} sem mensagem</small>
                </div>
              </div>
              <div class="col-6">
                <div class="p-2 bg-light rounded">
                  <small class="text-muted d-block">Total Mensagens</small>
                  <strong class="fs-5 text-primary">{{ resumoPerformanceLista.totalMensagens | number
                    }}</strong>
                  <small class="text-muted d-block">Média: {{
                    formatarDecimal(resumoPerformanceLista.mediaMensagensPorContato) }}</small>
                </div>
              </div>
            </div>

            <!-- Taxa de Cobertura -->
            <div class="mb-3">
              <div class="d-flex justify-content-between align-items-center p-2 bg-success-subtle rounded">
                <span class="text-success fw-bold">Taxa de Cobertura:</span>
                <span class="text-success fw-bold fs-5">{{
                  formatarPercentual(resumoPerformanceLista.taxaCoberturaMensagens) }}</span>
              </div>
              <small class="text-muted">
                {{ resumoPerformanceLista.contatosComMensagem }} de {{ resumoPerformanceLista.totalContatos
                }} contatos receberam mensagem
              </small>
            </div>

            <!-- Mensagens por Atendente -->
            <div
              *ngIf="resumoPerformanceLista.mensagensPorAtendente && resumoPerformanceLista.mensagensPorAtendente.length > 0">
              <h6 class="mb-2">
                <i class="fas fa-users me-1"></i>
                Mensagens por Atendente
              </h6>
              <div class="list-group list-group-flush">
                <div *ngFor="let atendente of resumoPerformanceLista.mensagensPorAtendente"
                  class="list-group-item d-flex justify-content-between align-items-center px-2 py-1">
                  <span class="fw-medium">{{ atendente.nomeAtendente }}</span>
                  <span class="badge bg-primary rounded-pill">{{ atendente.quantidadeMensagens | number }}
                    mensagens</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Mensagem quando não há lista selecionada -->
          <div *ngIf="!listaIdParaResumo && !carregandoResumo" class="text-center text-muted py-3">
            <i class="fas fa-info-circle me-1"></i>
            Selecione uma lista acima para ver o resumo detalhado
          </div>
        </div>
      </div>
    </div>
  </div>
  
